import React, { FC } from 'react';
import classnames from 'classnames';

import '@eika/checkmark-animation-style';

export enum CheckmarkAnimationTypes {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}

export interface CheckmarkAnimationProps {
    checkmarkAnimationType?: CheckmarkAnimationTypes;
    /**
     * Your own class name
     */
    className?: string;
    mini?: boolean;
}

const CheckmarkAnimation: FC<CheckmarkAnimationProps> = ({
    className,
    mini,
    checkmarkAnimationType = CheckmarkAnimationTypes.POSITIVE,
}) => {
    return (
        <span
            className={classnames(
                'sgw-checkmark-animation',
                className,
                `checkmark-animation--${checkmarkAnimationType}`,
                { 'checkmark--mini': mini },
            )}
            aria-hidden
        >
            <svg viewBox="0 0 500 500">
                <polyline className="checkmark" points="145.25 250.6 211.06 341.6 439.25 82.6" />
                <path
                    className="arc"
                    d="M351.19,75.55A195.06,195.06,0,0,0,250.25,47.6c-108.24,0-196,87.75-196,196s87.76,196,196,196,196-87.76,196-196a196.88,196.88,0,0,0-4-39.5"
                />
            </svg>
        </span>
    );
};

export default CheckmarkAnimation;
